<template>
	<div class="ReSelectSovmestService">
		<div class="row checkbox-radios">
			<div class="col-12">
				<base-radio v-for="(el_opt, el_index) in masRadio" :key="el_opt.name+'_'+el_index" :name="el_opt.name" v-model="value.rb_choice" inline>{{el_opt.label}}</base-radio>
			</div>
		</div>
		<div class="row select" v-if="value.rb_choice == '1'">
			<ReTagGroupList
				class="col-12 mt-2"
				v-model="value.masStaff"
				name="StaffList"
				:placeholder="placeholder"
				:objApiMethod="objApiMethod"
				:strApiMethodKey="strApiMethodKey"
			/>
		</div>
	</div>
</template>

<script>
	import { BaseRadio } from 'src/components/index';
	import ReTagGroupList from 'src/our_components/ReTagGroupList.vue';
	export default {
		name: 'ReSelectSovmestService',
		components: {
			BaseRadio,
			ReTagGroupList
		},
		props: {
			value: [Object, Array],
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			placeholder: String,
			objApiMethod: Object,
			strApiMethodKey: String
		},
		data () {
			return {
				ver: 1,
				masRadio:[{name: '0', label: 'Личная',}, {name: '1', label: 'Совместная',}],
			}
		},
		computed: {

		},
		methods: {

		},
	}
</script>
<style scoped>

</style>
